import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import DailyBookings from "../../components/charts/MonthlyBookings.jsx";
import MonthlyRevenue from "../../components/charts/MonthlyRevenue";
import NewUsersDaily from "../../components/charts/MonthlyNewUsers.jsx";
import DashboardStatistics from "./components/DashboardStatistics";
import { dashboardService } from "../../services/dashboardService.js";
import { toast } from "../../services/toastService.js";
import Loading from "../../components/common/Loading.jsx";
import MonthlyBookings from "../../components/charts/MonthlyBookings.jsx";
import CategoryStatistics from "./components/CategoryStatistics.jsx";
import MonthlyNewUsers from "../../components/charts/MonthlyNewUsers.jsx";
import CityStatistics from "./components/CityStatistics.jsx";
import LatestBooking from "./components/LatestBooking.jsx";
import LoadingData from "../../components/common/LoadingData.jsx";

const Dashboard = () => {
  const { t,lang } = useContext(LocaleContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    getDashboardData();
  },[]);

  const getDashboardData = async () => {
    try {
      setLoading(true);
      const response = await dashboardService.getStatisticsAsync();
      console.log(response);

      if(!response.isSuccess){
        console.log(response);
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        return;
      }
      setData(response.value);
      // Process the data as needed
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  if (loading) return  <LoadingData t={t} />;

  return (
    <section className="section-dashboard">
      <div className="default-heading">{t("dashboard")}</div>
      <DashboardStatistics
        t={t}
        user={data?.user}
        provider={data?.provider}
        trip={data?.trip}
        revenue={data?.revenue}
      />
      <section className="section-dashboard-charts">
        <div className="row g-3">
          <div className="col-12 col-xl-7">
            <div className="chart-card">
              <MonthlyRevenue
                title={t("monthlyRevenue")}
                height={400}
                thisYear={data?.monthlyRevenue?.thisYear}
                lastYear={data?.monthlyRevenue?.lastYear}
              />
            </div>
          </div>
          <div className="col-12 col-xl-5">
            <div className="chart-card">
              <MonthlyBookings title={t("monthlyBookings")} height={400} monthlyBooking={data?.monthlyBooking} />
            </div>
          </div>
          <div className="col-12 col-xl-7">
            <CategoryStatistics t={t} lang={lang} category={data?.categoryStatistics} />
          </div>
          <div className="col-12 col-xl-5">
            <div className="chart-card">
              <MonthlyNewUsers title={t("monthlyNewUsers")} height={259} monthlyNewUser={data?.monthlyNewUser} />
            </div>
          </div>
          <div className="col-12 col-xl-7">
            <CityStatistics t={t} lang={lang} cityStatistics={data?.cityStatistics} />
          </div>
          <div className="col-12 col-xl-5">
           <LatestBooking t={t} lang={lang} latestBookings={data?.latestBookings} />
          </div>
        </div>
      </section>
    </section>
  );
};

export default Dashboard;
